import { useEffect, useReducer } from 'react';
import { fetchReducer, FETCH_ACTION_TYPES } from 'reducers/fetchReducer';
import { referralHistory } from 'api/user/referralHistory';

const initialState = {
  loading: false,
  error: false,
  data: null,
};

const useInviteHistoryFetch = (isModalOpen = false) => {
  const [state, dispatch] = useReducer(fetchReducer, initialState);
  useEffect(() => {
    let ignore = false;
    const fetch = async () => {
      dispatch({ type: FETCH_ACTION_TYPES.loading, payload: { loading: true } });
      try {
        const response = await referralHistory();
        const userReferrals = response.userReferrals || [];
        if (!ignore) {
          dispatch({ type: FETCH_ACTION_TYPES.setData, payload: { data: userReferrals } });
        }
      } catch (e) {
        if (!ignore) {
          dispatch({ type: FETCH_ACTION_TYPES.setError, payload: { error: e } });
        }
      }
    };

    if (isModalOpen) {
      fetch();
    }

    return () => {
      ignore = true;
    };
  }, [isModalOpen]);

  return [state];
};

export default useInviteHistoryFetch;
